import { CountryCode } from "services/translation/country-code";

export class DisplayNames {
    public get DisplayNames(): Map<string, string> {
        return this.names
    }

    constructor(private names: Map<string, string>) { }

    public static create(): DisplayNames {
        return new DisplayNames(new Map())
    }

    public getName(countryCode: CountryCode): string | undefined {
        return this.names?.get(countryCode)
    }
}